import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestServeComponent } from './test-serve/test-serve.component';
import { ToolboxModule } from "../shared/toolbox/toolbox.module";
import {CompareDialogComponent} from '../shared/toolbox/dialogs/compare-dialog/compare-dialog.component';
import { ChartsModule } from '../shared/toolbox/charts/charts.module';
import { ChartWrapperComponent } from '../shared/toolbox/charts/chart-wrapper/chart-wrapper.component';
import { MetricTableComponent } from "../shared/toolbox/charts/metric-table/metric-table.component";



@NgModule({
  declarations: [
    TestServeComponent
  ],
  imports: [
    CommonModule,
    CompareDialogComponent,
    ChartsModule,
    ChartWrapperComponent,
    ToolboxModule,
    MetricTableComponent
],
  exports: [TestServeComponent]
})
export class TestModule { }
